var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './index.scss';
var Icon = function (_a) {
    var icon = _a.icon, onClick = _a.onClick;
    return (_jsx("div", __assign({ className: "Icon", onClick: onClick }, { children: _jsx("div", __assign({ className: "iconContainer" }, { children: icon }), void 0) }), void 0));
};
export default Icon;
